import { router, formatHelpers, useTranslation } from '@hfc/ui-core';
interface UseUrlHelperInterface {
  getRouteNameByAppType: (appType: string, routeSuffix: string) => string;
  getBaseUrl: (uri: string) => string;
  getIaFQuoteUrl: () => string;
  isSeniorPage: () => boolean;
  getSmallBusinessConsultationLink: () => string;
  getSmallBusinessConsultationPhone: () => string;
  getSmallBusinessQuoteReviewLink: () => string;
}

const { capitalizeFirstLetter } = formatHelpers();

export const useUrlHelper = (): UseUrlHelperInterface => {
  const { t } = useTranslation();

  const getRouteNameByAppType = (appType: string, routeSuffix: string): string => {
    const parts = appType.split('-');
    const capitalizedParts = parts.map(capitalizeFirstLetter);

    return `${capitalizedParts.join('')}${routeSuffix}`;
  };

  const getBaseUrl = (url: string): string => {
    return `${import.meta.env.VITE_APP_BASE_URL}${url}`;
  };

  const getIaFQuoteUrl = (): string => {
    return `${import.meta.env.VITE_APP_BASE_URL}/${t('links.individualAndFamilyQuote')}`;
  };

  const isSeniorPage = (): boolean => {
    const currentRouteName = router.currentRoute.value.name as string;

    return currentRouteName.includes('Senior');
  };

  const getSmallBusinessConsultationLink = (): string => {
    return `${import.meta.env.VITE_APP_SMALL_BUSINESS_CONSULTATION_LINK}`;
  };

  const getSmallBusinessConsultationPhone = (): string => {
    return `${import.meta.env.VITE_APP_SMALL_BUSINESS_CONSULTATION_PHONE}`;
  };

  const getSmallBusinessQuoteReviewLink = (): string => {
    return `${import.meta.env.VITE_APP_SMALL_BUSINESS_QUOTE_REVIEW_LINK}`;
  };

  return {
    getRouteNameByAppType,
    isSeniorPage,
    getIaFQuoteUrl,
    getSmallBusinessConsultationLink,
    getSmallBusinessConsultationPhone,
    getSmallBusinessQuoteReviewLink,
    getBaseUrl
  };
};
